<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-layout justify-center wrap py-8>
          <v-flex xs12>
            <v-card>
              <v-flex xs12>
                <v-card color="#434343" outlined class="mx-auto">
                  <v-layout justify-end wrap>
                    <v-flex xs10 px-5 align-self-end text-right>
                      <v-icon
                        color="white"
                        size="15"
                        @click="$refs.showImage.click()"
                        >mdi-folder-edit-outline</v-icon
                      >
                      <span
                        style="
                          color: white;
                          font-family: nunitosansregular;
                          font-size: 12px;"
                        >Edit Photo</span
                      >
                      <input
                        v-show="false"
                        accept="image/*"
                        id="file"
                        ref="showImage"
                        multiple="multiple"
                        type="file"
                        @change="showImage"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center wrap pt-3 pb-5 v-if="admin">
                    <v-flex xs12 sm12 md12 text-center>
                      <v-layout justify-center wrap>
                        <v-flex xs12>
                          <v-avatar style="cursor: pointer" size="80">
                            <v-img :src="mediaURL + admin.photo" />
                          </v-avatar>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            style="
                              color: #ffffff;
                              font-family: nunitosanssemibold;
                              font-size: 18px;"
                            >{{ admin.name}}
                          </span
                          ><br />
                          <span
                            style="
                              font-family: nunitosansbold;
                              color: #ffffff;
                              font-size: 12px;"
                            >{{admin.currentRole}}</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-layout justify-center wrap v-if="admin">
                <v-flex xs12>
                  <v-card-text>
                    <v-layout justify-start px-5 wrap py-5>
                      <v-flex xs12 sm12 md6>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 18px;"
                          >Personal Information</span
                        >
                        <v-layout justify-center wrap py-5>
                          <v-flex xs2 sm2 md1>
                            <v-img
                              width="25px"
                              src="../../assets/images/male black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Gender</span>
                            <br />
                            <span class="content" v-if="admin.gender">{{ admin.gender }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1>
                            <v-img
                              width="25px"
                              src="../../assets/images/cake black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">DOB</span>
                            <br />
                            <span class="content" v-if="admin.dob">{{
                              admin.dob.slice(0, 10)
                            }}</span>
                          </v-flex> </v-layout>
                          <v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/phone iphone black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Contact</span>
                            <br />
                            <span class="content">{{ admin.phone }}</span>
                            <br />
                          </v-flex> </v-layout>
                          <v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1>
                            <v-img
                              width="25px"
                              src="../../assets/images/home black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Address</span>
                            <br />
                            <span class="content" v-if="admin.address">{{
                              admin.address
                            }}</span>
                          </v-flex> </v-layout>
                        <v-layout justify-center wrap pb-5>
                          <v-flex xs2 sm2 md1 pt-2>
                            <v-img
                              width="25px"
                              src="../../assets/images/email black 24dp.png"
                            />
                          </v-flex>
                          <v-flex xs10 sm10 md11>
                            <span class="heading">Email</span>
                            <br />
                            <span class="content">{{ admin.email }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md6 text-right>
                        <v-dialog v-model="editdialog" max-width="700px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="16" v-bind="attrs" v-on="on"
                              >mdi-folder-edit-outline</v-icon
                            >
                          </template>
                          <v-card>
                            <v-card-text>
                              <v-layout justify-start wrap pt-5>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="admin.name"
                                    class="text"
                                    label="Last Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-select
                                    dense
                                    label="Gender"
                                    outlined
                                    class="text"
                                    v-model="admin.gender"
                                    hide-details
                                    :items="genders"
                                  >
                                  </v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="admin.dob"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="admin.dob"
                                        label="DOB"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="admin.dob"
                                      max="2000-01-1"
                                      no-title
                                      scrollable>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false">
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(admin.dob)">
                                        OK
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="admin.email"
                                    class="text"
                                    label="Email"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="admin.phone"
                                    class="text"
                                    label="Contact"
                                    outlined
                                    type="number"
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 pa-2>
                                  <v-text-field
                                    v-model="admin.address"
                                    class="text"
                                    label="Address"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-layout justify-center wrap>
                                <v-flex xs6 sm4 px-2>
                                  <v-btn
                                    block
                                    tile
                                    color="#757575"
                                    outlined
                                    :ripple="false"
                                    depressed
                                    @click="editdialog = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-flex>
                                <v-flex xs6 sm4 px-2>
                                  <v-btn
                                    tile
                                    block
                                    dark
                                    color="#FF1313"
                                    depressed
                                    class="text-capitalize"
                                    :ripple="false"
                                    @click="edit()"
                                  >
                                    Save
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <span
                          style="
                            font-family: nunitosansregular;
                            font-size: 12px;"
                          >Edit Information</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store"
export default {
//   props: ["id"],
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      editdialog: false,
      menu: false,
      cgpi: 50,
      admin:[],
      file1: null,
      genders: ["Male", "Female", "Other"],

    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.admin = response.data.data;
          store.commit("myPic",response.data.data.photo)
          this.admin.dob=this.admin.dob.slice(0, 10)
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
     edit() {
      this.appLoading = true;
      var user = {};
      user["name"] = this.admin.name;
      user["phone"] = this.admin.phone;
      user["email"] = this.admin.email;
      user["gender"] = this.admin.gender;
      user["address"]=this.admin.address;
      user["dob"] = this.admin.dob;
      user["id"] = this.admin._id;
      axios({
        method: "POST",
        url: "/user/Edit",
        data: user,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.msg = "Teacher Update Successully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.editdialog = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    showImage(e) {
      this.file1 = e.target.files[0];
      console.log(e);
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file1.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreview = true;
      if (this.file1) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
          reader.readAsDataURL(this.file1);
        }
        this.uploadImage();
      }
    },
    uploadImage() {
      let formData = new FormData();
      formData.append("photo", this.file1);
      formData.append("id", this.admin._id);
      axios({
        method: "POST",
        url: "/User/adminUploadImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.showPreview = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.heading {
  color: #4d4d4d;
  font-family: nunitosanslight;
  font-size: 12px;
}
.content {
  color: #000000;
  font-family: nunitosansregular;
}
.subject {
  color: #4d4d4d;
  font-family: nunitosansregular;
  font-size: 12px;
}
</style>